<template lang="html">
  <div id="join-page">

    <section class="form-section">
      <b-form class="container" @submit="onSubmitForm">
        <div class="row justify-content-center">
          <div class="col-lg-9 col-form">
            <div class="box-white">

              <div class="row" v-if="step <= 2">
                <div class="col-12 text-center text-sm-right mb-2 mb-lg-0 ml-auto">
                  <h1 class="text-center mb-2 title-s1" style="letter-spacing: 4px;" v-if="step == 1">¡AFÍLIATE!</h1>

                  <!-- <h6 class="d-block d-sm-inline-block"><strong>FECHA:</strong> 10/12/2025</h6>
                  <span class="d-none d-sm-inline-block mx-2">|</span>
                  <h6 class="d-block d-sm-inline-block"><strong>AFILIADO NO:</strong> 56506</h6> -->
                </div>
              </div>

              <!-- Paso 1 -->
              <div class="row" v-if="step == 1">
                <div class="col-12 col-i">
                  <h6 class="subtitle">PATROCINADOR</h6>
                  <hr class="sep" />
                </div>

                <div class="col-12 mb-4">
                  <div class="row align-items-end">
                    <div class="col-7 col-lg-8 col-i">
                      <b-form-group class="mb-0 custom-form-group-s1" label="INGRESE SU CODIGO FEROS*">
                        <b-form-input
                          v-model="search_sponsor"
                          type="text"
                        ></b-form-input>
                      </b-form-group>
                    </div>

                    <div class="col-5 col-lg-3 col-i pl-0">
                      <b-button type="button" class="btn btn-s1 outline-c-primary w-100" @click="searchSponsor">BUSCAR</b-button>
                    </div>
                  </div>
                  <div class="alert alert-info col-11 mt-3 mb-0" v-if="sponsordata.id" style="padding-top: 10px;">
                    <b>Patrocinador relacionado:</b> ID:{{sponsordata.id}} - Nombre: {{ sponsordata.name_lastname }}
                  </div>
                </div>

                <div class="col-12 col-i pt-2 mt-1">
                  <h6 class="subtitle">SOLICITANTE</h6>
                  <hr class="sep" />
                </div>

                <div class="col-lg-4 col-i">
                  <b-form-group class="custom-form-group-s1" label="APELLIDO PATERNO*">
                    <b-form-input
                      v-model="joinForm.lastname_p"
                      type="text"
                      placeholder=""
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-lg-4 col-i">
                  <b-form-group class="custom-form-group-s1" label="APELLIDO MATERNO*">
                    <b-form-input
                      v-model="joinForm.lastname_m"
                      type="text"
                      placeholder=""
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-lg-4 col-i">
                  <b-form-group class="custom-form-group-s1" label="NOMBRE*">
                    <b-form-input
                      v-model="joinForm.name"
                      type="text"
                      placeholder=""
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-lg-4 col-i">
                  <b-form-group class="custom-form-group-s1" label="CELULAR*">
                    <b-form-input
                      v-model="joinForm.movil"
                      type="text"
                      placeholder=""
                      minlength="10"
                      maxlength="10"
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-lg-4 col-i">
                  <b-form-group class="custom-form-group-s1" label="CORREO ELECTRÓNICO*">
                    <b-form-input
                      v-model="joinForm.email"
                      type="email"
                      placeholder=""
                      required
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-12 text-right">
                  <p>
                    <b-button type="submit" class="btn btn-s1 btn-lg bg-c-primary px-5">SIGUIENTE</b-button>
                  </p>
                </div>
              </div>
              <!--  -->

              <!-- Paso 2 -->
              <div class="row mt-1" v-if="step == 2">
                <div class="col-12 col-top">
                  <h3 class="title-2">Afiliate en 2 pasos</h3><br>
                  <h5 class="mb-2">
                    <b>Paso 1:</b> Elige uno de nuestros Kits de Afiliación
                  </h5>

                  <div class="d-block mt-1 pt-1">
                    <div class="btn btn-s1 outline-c-tertiary btn-kits" v-bind:class="{ 'active' : currentKitId == k.id }" @click="selectKit(kInx)" v-for="(k, kInx) in membershipKits" :key="'kInx-'+kInx">
                      <h5 class="k-title">{{ k.name }}</h5>
                      <p>Hasta <strong class="f-w-700">{{ k.quantity }}</strong> productos por<br /></p>
                      <h6 class="mt-3 mt-sm-2 k-price">${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(k.price) }} M.N.</h6>
                      <a><i class="fa-sharp fa-solid fa-arrow-pointer"></i> Seleccionar productos</a>
                    </div>
                  </div>
                </div>

                <!-- Espacio mientras se carga el elemento de stripe -->
                <div class="d-block px-5 py-4" v-if="currentKitId == null"></div>

                <div class="col-12 mb-1 mt-3 col-selected-option" v-if="currentKitId != null">
                  <div class="row">
                    <div class="col-12 col-totals">
                      <hr class="mt-1" />
                      
                      <div class="b-totals">
                        <h6><span class="t-label">Subtotal:</span> <strong>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(joinForm.subtotal) }} M.N.</strong></h6>
                        <h6><span class="t-label">Costo de envío:</span> <strong>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(joinForm.shipping) }} M.N.</strong></h6>
                        <h5><span class="t-label">Total a pagar:</span> <strong>$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(joinForm.total) }} M.N.</strong></h5>
                      </div>
                      
                      <hr class="mt-3 mb-1" />
                    </div>

                    <div class="col-12 col-card" v-if="paymentOpt == 2">
                      <h5 class="mt-3">
                        <b>Paso 2:</b> Ingresa los datos de tu tarjeta de credito o debito para pagar de forma segura el monto de <strong class="f-w-700">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(joinForm.total) }} M.N.</strong>
                      </h5>

                      <div class="row justify-content-center">
                        <div class="col-12 col-payment-logos mt-2">
                          <p class="text-center">
                            <img class="img-payment" src="public/images/shared/payment.svg">
                          </p>
                        </div>

                        <div class="col-12">
                            <div id="cardElement"></div>
                            <small class="form text text-muted" id="cardErrors" role="alert"></small>
                        </div>

                        <div class="col-12 text-center mt-4">
                          <p>
                            <b-button type="submit" class="btn btn-s1 btn-lg bg-c-primary px-5 btn-same-w"><i class="fa-regular fa-lock-keyhole"></i> ¡PAGAR <strong>${{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(joinForm.total) }}</strong> Y AFILIARTE!</b-button>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  -->

              <!-- Paso 3 -->
              <div class="row" v-if="step == 3">
                <div class="col-12 col-thanks">
                  <div class="success-checkmark">
                    <div class="check-icon">
                      <span class="icon-line line-tip"></span>
                      <span class="icon-line line-long"></span>
                      <div class="icon-circle"></div>
                      <div class="icon-fix"></div>
                    </div>
                  </div>
                  <!-- <p class="mb-4">
                    <img class="logo" src="public/images/logo.png">
                  </p> -->

                  <h3 class="mb-3 f-w-600" style="letter-spacing: 2px;">¡Gracias por afiliarte!</h3>

                  <h5 class="mb-1">Afiliado no. <strong>{{record.id}}</strong></h5>


                  <p class="mt-4">
                    <a class="btn-s1 bg-c-primary" style="font-size: 1.1rem;" @click="completarReg()"><i class="fas fa-user-edit"></i> Completar el registro</a>
                  </p>

                  <div class="mt-5">
                    <hr class="mb-2" />
                    <router-link class="txt-c-2 f-w-600" to="/"><i class="far fa-home-alt"></i> Ir al Inicio</router-link>
                  </div>
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </div>
      </b-form>
    </section>

    <b-modal modal-class="modal-info-s2" ref="modal-products" title="" scrollable centered hide-footer no-close-on-backdrop no-close-on-esc>
      <div>
        <h4 class="text-center modal-title">Productos incluidos en tu afiliacion</h4><br>
        <p class="text-center">Elige hasta <strong>{{ currentKit.quantity }}</strong> productos.<br>Puedes repetir productos, siempre y cuando no excedan los <strong>{{ currentKit.quantity }}</strong> seleccionados.</p>

        <div class="box-products">
          <!-- Mostrar productos de tipo plus unicamente cuando el currentKit.id == 2 -->
          <div class="row"
            v-if="(currentKit.id == 1 && p.plus == 0) || (currentKit.id == 2 && (p.plus == 1 || p.plus == 0))"
            v-for="(p, pInx) in products" :key="'pInx-'+pInx">
            <div class="col">
                <router-link class="row row-product" target="_blank"  :to="'/producto/'+$root._converToURL(p.name, p.id)">
                  <div class="col col-image">
                    <img class="placed-backg" src="public/images/pages/products/product.png" v-bind:style="{ backgroundImage: 'url('+p.image+')' }">
                  </div>

                  <div class="col col-text">
                    <h6 class="sku">{{ p.sku }}</h6>
                    <h6 class="name">{{ p.name }}</h6>
                    <h6 class="presentation" v-if="p.model">{{ p.model.name }}</h6>
                    <!-- <h6 class="price" v-if="p.model">${{ p.model.price }}</h6> -->
                    <h6 class="type"><span v-if="p.plus">Producto Plus</span></h6>
                  </div>
                </router-link>
            </div>
            <div class="col align-self-center px-0 col-btn">
              <div>
                <a class="btn btn-danger btn-sm" @click="p.quantity = 0" style="padding: 0.30rem 0.65rem;"><i class="fa fa-times"></i>
                </a>
              </div>
            </div>
            <div class="col align-self-center col-quantity">
              <quantityComponent v-model="p.quantity" :maxStock="p.max_quantity" />
              <!-- <div><input type="number" v-model="p.quantity" :min="0" class="form-control quantity-input" /></div> -->
            </div>
          </div>
        </div>

        <!-- Botón flotante siempre visible -->
        <div class="floating-button-container">
          <button
            class="btn btn-s1 bg-c-primary floating-confirm-btn"
            style="color:white;background-color: #a41f1b;border-color: #a41f1b;"
            @click="confirmarSeleccion"
          >
            Confirmar seleccion<br><small>{{ sub_quantity }} productos seleccionados</small>
          </button>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import quantityComponent from './quantity-component.vue';
export default {
  components: {
    quantityComponent
  },

  data() {
    return {
      step: 1,

      paymentOpt: 2,
      search_sponsor:null,
      joinForm: {
        name: null,
        users_id_sponsor:null,
        shipping: 0,
        subtotal: 0,
        total: null,
        kit_id: null,
      },

      membershipKits: [],
      currentKit: {
        id: null,
        name: null,
        quantity: 1,
        price: 0,
      },
      currentKitId: null,

      products: [],
      record:{
        id:null,
        date:null,
      },
      sub_quantity:0,
      sponsordata:{},
    }
  },

  methods: {
    confirmarSeleccion() {
      // Usar el contador ya calculado en tiempo real
      if(this.sub_quantity > this.currentKit.quantity) {
        this.$root.modaldata.icon = 'warning';
        this.$root.modaldata.msg = 'No puedes seleccionar mas de '+this.currentKit.quantity+' productos';
        this.$root.modaldata.show = true;
        return;
      }

      if(this.sub_quantity < this.currentKit.quantity) {
        this.$root.modaldata.icon = 'warning';
        this.$root.modaldata.msg = 'Debes seleccionar al menos '+this.currentKit.quantity+' productos';
        this.$root.modaldata.show = true;
        return;
      }

      // Si pasa todas las validaciones, cerrar el modal y continuar
      this.currentKitId = this.currentKit.id;
      this.joinForm.subtotal = parseFloat(this.currentKit.price);
      this.joinForm.total = parseFloat(this.currentKit.price) + parseFloat(this.joinForm.shipping);;
      this.joinForm.kit_id = this.currentKit.id;
      this.$refs['modal-products'].hide();

      setTimeout(() => {
        this.loadStripe();
      }, 200);
    },

    selectKit(idx) {
      // Resetear valores
      this.currentKitId = null;
      this.joinForm.subtotal = 0;
      this.joinForm.total = null;
      this.joinForm.kit_id = null;

      // Asignar kit seleccionado temporal a currentKit
      this.currentKit = this.membershipKits[idx];
      this.$refs['modal-products'].show();

      // Resetear los quantities de los productos
      let productsArr = this.products.map(item => {
        return { ...item, quantity: 0 };
      });
      this.products = productsArr;

      // Distribuir los productos requeridos en los inputs quantity segun se requiera
      let totalProducts = this.products.length;
      let currentKitQuantity = this.currentKit.quantity;
      let counter = 0;

      for (let i = 0; i < currentKitQuantity; i++) {
        for (let i = 0; i < totalProducts; i++) {
          counter++;

          if(counter > currentKitQuantity) {
            break
          }else {
            this.products[i].quantity++;
          }
        }

        if(counter > currentKitQuantity) {
          break
        }        
      }
    },

    onSubmitForm(event) {
      event.preventDefault();

      if(this.step == 2) {
        this.$root.isLoading = true;

          this.stripe.createPaymentMethod({
            type: 'card',
            card: this.cardElement,
            billing_details: { name: this.joinForm.name+' '+this.joinForm.lastname_p+' '+this.joinForm.lastname_m, email: this.joinForm.email }
            }).then((result)=>{
            if (result.error) {
                alert('Ocurrió un error con su tarjeta');

                this.$root.isLoading = false;
            } else {
                const data  = { payment_method_id: result.paymentMethod.id, total: this.joinForm.total, name: this.joinForm.name+' '+this.joinForm.lastname_p+' '+this.joinForm.lastname_m, email: this.joinForm.email , products: this.products};
                axios.post(tools.url('/api/stripe/Installments'),data).then((response)=>{
                    this.joinForm.payment_intent_id = response.data.intent_id;
                    this.sendForm();
                }).catch((error)=>{
                    this.$root.isLoading = false;
                    this.$root.modaldata.icon = 'warning';
                    this.$root.modaldata.msg = error;
                    this.$root.modaldata.show = true;
                });
            }
        });
      }
      else if(this.step == 1) {
        if(this.joinForm.name == null || this.joinForm.lastname_p == null || this.joinForm.lastname_m == null || this.joinForm.movil == null || this.joinForm.email == null) {
          this.$root.modaldata.icon = 'warning';
          this.$root.modaldata.msg = 'Por favor, completa todos los campos requeridos';
          this.$root.modaldata.show = true;
          this.step = 1;
          return;
        }

        this.step = 2;
      // setTimeout(() => {
      //   this.loadStripe();
      // }, 200);

      }
    },

    completarReg() {
      setTimeout(()=> {
        this.$router.push({ path: '/usuario' });
      }, 250);
    },

    searchSponsor(){
        this.$root.isLoading = true;
        axios.post(tools.url('/api/searchsponsor'),{ phone: this.search_sponsor }).then((response)=>{
            var res = response.data;
       
            this.$root.isLoading = false;
            this.sponsordata = res;
            this.$root.modaldata.icon = 'success';
            this.$root.modaldata.msg = 'Afiliado patrocinador encontrado exitosamente:<br><b>'+res.id+' <br> '+res.name_lastname+'</b>';
            this.$root.modaldata.show = true;
            this.joinForm.users_id_sponsor = res.id;
        }).catch((error)=>{
            this.$root.isLoading = false;
            this.$root.modaldata.icon = 'warning';
            this.$root.modaldata.msg = 'No se encontro registro con numero ingresado ';
            this.$root.modaldata.show = true;
        });
    },

    loadStripe(){
      //sandbox key
      this.stripe = Stripe('pk_live_51Rb39hHPK0VoywknGgflPltojpAHZeyuvUgJkjwXIztXA5FW6M2tA1s0OcQnlldvrPSDWjZP5oUf44mWJlU75KnP00oMIvW72c');

      this.elements = this.stripe.elements({locale: 'es'});
      this.cardElement = this.elements.create('card', {hidePostalCode: true});

      this.cardElement.mount("#cardElement");
      this.cardElement.addEventListener('change', ({ error }) => {
          const displayError = document.getElementById('cardErrors');
          if (error) {
            displayError.textContent = error.message;
          } else {
            displayError.textContent = '';
          }
      });
    },

    sendForm(){
      this.joinForm.products = this.products;
        axios.post(tools.url('/api/user/saveAffiliate'),this.joinForm).then((response)=>{
              var res = response.data;
              this.$root.auth();
              this.record.id = res.id;
                this.step = 3;
              this.$root.isLoading = false;
          }).catch((error)=>{
                 this.step = 2;
                this.$root.isLoading = false;
                this.$root.modaldata.icon = 'warning';
                this.$root.modaldata.msg = error;
                this.$root.modaldata.show = true;
          });
    },

    getMembershipKits() {
      axios.get(tools.url('/api/membership_kits')).then((response)=>{
        this.membershipKits = response.data;
      }).catch((error)=>{
        console.warn(error);
      });
    },

    getShippingCost(){
      axios.get(tools.url('/api/cost_shipping')).then((response)=>{
          this.joinForm.shipping = response.data;
      }).catch((error)=>{
        console.warn(error);
      });
    },

    getProducts() {
      axios.get(tools.url('/api/affiliate_products')).then((response)=>{
        this.products = response.data;
        // Inicializar cantidades en 0 y contador
        this.products.forEach(product => {
          if (product.quantity === undefined || product.quantity === null) {
            product.quantity = 0;
          }
        });
        this.actualizarContador();
      }).catch((error)=>{
        console.warn(error);
      });
    },

    actualizarContador() {
      var sub_quantity = 0;
      for(let i = 0; i < this.products.length; i++) {
        if(this.products[i].quantity > 0 && this.products[i].quantity != null && this.products[i].quantity != '' && this.products[i].quantity != '0') {
          sub_quantity = sub_quantity + parseInt(this.products[i].quantity);
        }
      }
      this.sub_quantity = sub_quantity;
    }
  },

  watch: {
    'joinForm.cardExp':function(){
      // Card number without dash (-)
        let realNumber = this.joinForm.cardExp.replace(/\//gi, '')

        // Generate dashed number
        let dashedNumber = realNumber.match(/.{1,2}/g)

        // Replace the dashed number with the real one
        this.joinForm.cardExp = dashedNumber.join('/')
    },

    // Watcher para productos - actualiza contador en tiempo real
    'products': {
      handler: function(newProducts) {
        this.actualizarContador();
      },
      deep: true
    },

    // Watcher específico para cambios en las cantidades
    // 'products.*.quantity': function(newQuantity) {
    //   this.actualizarContador();
    // },

    // Watcher específico para cambios en las cantidades
    products: { // Reemplazo de la función de arriba con el "products.*.quantity"
      handler(newProducts) {
        newProducts.forEach(product => {
          this.actualizarContador();
        });
      },
      deep: true
    }
  },

  mounted() {
    this.getMembershipKits();
    // this.getPrice();
    this.getShippingCost();
    this.getProducts();
  }
}
</script>
<style>
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

/* Estilos para el botón flotante */
.floating-button-container {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  pointer-events: auto;
  margin-top: 20px;
  text-align: center;
  width: 100%;
}

.floating-confirm-btn {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-radius: 25px;
  padding: 12px 30px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
  min-width: 200px;
  line-height: 1.2 !important;
}

.floating-confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
}

/* Asegurar que el botón sea visible en el modal */
.modal-info-s2 .floating-button-container {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: linear-gradient(to top, rgba(255,255,255,0.95) 80%, rgba(255,255,255,0));
  padding: 20px 0 10px 0;
  border-top: 1px solid rgba(0,0,0,0.1);
}
</style>
